import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../models/result.model';
import {
  ResourceSalutation,
  ResourceCountry,
  ResourceLanguage,
  ResourceProvinces,
  ResourceCurrencies,
  ResourceIsoLanguage
} from '../../models/resources/resources.model';

/** Injection token for the data service */
export const RESOURCES_DATA_SERVICE = new InjectionToken<ResourcesDataService>('[Resources] ResourcesDataService');

export interface ResourcesDataService {

  getResourceCountries(): ObservableResult<ResourceCountry[]>;

  getResourceLanguages(): ObservableResult<ResourceLanguage[]>;

  getResourceIsoLanguages(): ObservableResult<ResourceIsoLanguage[]>;

  getResourceCurrencies(): ObservableResult<ResourceCurrencies[]>;

  getResourceSalutation(): ObservableResult<ResourceSalutation[]>;

  getResourceProvinces(): ObservableResult<ResourceProvinces[]>;

  getResourcesTranslations(domain: string): ObservableResult<any>;

  getResourcesTranslationsByLanguageCode(domain: string, languageCode: string): ObservableResult<any>;
}
